<!-- @veltra/icons generated sha256:8b13eceabf752a29 gen:8 source:src/svg/normal/terminal.svg -->
<script setup lang="ts">
defineOptions({ name: 'Terminal' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <path d="M12 19h8M4 17l6-6-6-6" />
  </svg>
</template>
